<template>
    <div class="backdrop" @click.self="onCancel">
        <div class="new-item">
            <div style="display:flex;justify-content:center">{{ title }}</div>
            <div style="margin-bottom:10px"><hr /></div>
            <div style="display:flex;justify-content:space-between; flex-direction: column;height:100%">
                <div class="tenant-input-container">
                    <div style="width:100%;text-align: start;margin-bottom: 20px;">Username</div>
                    <input @focus="clearError" ref="refInput" class="item-input" type="text" v-model="username" maxlength="30" @keyup="processKeyPress" style="width:100%" :disabled="processing"/>
                </div>

                <div class="tenant-input-container">
                    <div style="width:100%;text-align: start;margin-bottom: 20px;">Password</div>
                    <input @focus="clearError" class="item-input" type="password" v-model="password" maxlength="30" @keyup="processKeyPress" style="width:100%" :disabled="processing"/>
                </div>

                <div style="color:red;font-size:10pt;text-align:center">
                    {{ errorMessage }}
                </div>
                <div class="new-item-button-bar" v-if="!processing">
                    <button class="new-item-button" @click="onOk">
                        Enter
                    </button>
                    <button class="new-item-button" @click="onCancel">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
    setup(props, { emit }) {
        const username = ref("");
        const password = ref("");
        const refInput = ref(null);
        const errorMessage = ref("");
        const title = ref("");
        
        const processing = ref(false);
        var operation = "";

        const initWindow = (pTitle, pOperation) => {
            title.value = pTitle;                                            
            operation = pOperation;
            
            username.value = "";
            password.value = "";

            setTimeout(function() {
                refInput.value.focus();
            }, 50);
        };        

        const onCancel = () => {
            emit("on-cancel");
        };

        const onOk = async () => {
            processing.value = true;
            errorMessage.value = "";            

            await operation(username.value, password.value);
            emit("on-cancel");
            username.value = "";
            password.value = "";
            processing.value = false;
        };

        const clearError = () => {
            errorMessage.value = "";
        };

        onMounted(() => {
            processing.value = false;
            refInput.value.focus();
        });        

        const processKeyPress = (event) => {
            if (event.keyCode === 13) onOk();
            if (event.keyCode === 27) onCancel();
        };

        return {
            title,
            onCancel,
            refInput,
            onOk,
            username,
            password,
            errorMessage,
            clearError,
            processKeyPress,
            initWindow,                       
            processing
        };
    }
};
</script>

<style scoped>
.new-item {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 20%;
    left: 50%;
    margin-top: -205px;
    margin-left: -255px;
    width: 500px;
    height: 270px;
    background: var(--main-background);
    border-radius: 10px;
    padding: 30px;
    border: 1px solid var(--card-body-border);
}

.new-item-button-bar {
    display: flex;
    justify-content: flex-end;
    padding: 5px;
    margin: 0px;
}

.new-item-button {
    /* background-color: cornflowerblue; */
    color: var(--button-color);
    padding: 10px;
    margin-right: 10px;
    width: 125px;
    cursor: pointer;
}

.tenant-item {
    width: 500px;
    min-width: 100px;
}

.tenant-input-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 10px;
}

.item-input {
    width: 300px;
}
</style>
